export const siteConfig = {
  brandName: 'Hakuna Matata',
  tagline: 'African Style. Kenyan Spirit.',

  // WhatsApp expects the international format without plus sign and without local leading 0.
  whatsappNumber: '4367762884057',

  email: 'office@hakunamatata.at',
  phoneDisplay: '0677 628 840 57',
  phoneHref: '+4367762884057',

  address: {
    name: 'Hakuna Matata',
    street: 'Minoritenplatz 5, Tür 7',
    zip: '2620',
    city: 'Neunkirchen',
    country: 'Österreich',
    mapsUrl:
      'https://www.google.com/maps/search/?api=1&query=Minoritenplatz%205%202620%20Neunkirchen',
  },

  legal: {
    owner: 'Agelina Maureen Auro Schuh',
    companyName: 'Agelina Maureen Auro Schuh',
    gln: '9110027065225',

    businessAddress: {
      street: 'Minoritenplatz 5, Top 4',
      zip: '2620',
      city: 'Neunkirchen',
      country: 'Österreich',
    },

    authority: 'Bezirkshauptmannschaft Neunkirchen',

    trade: {
      title: 'LG Handel mit Mode und Freizeitartikel',
      wording: 'Handelsgewerbe mit Ausnahme der reglementierten Handelsgewerbe',
      gisa: '39304490',
      branch:
        'Handel mit Bekleidung und Textilien, Handel mit Leder-, Galanterie- und Bijouteriewaren, Handel mit Schuhen',
      since: '04.02.2026',
    },
  },

  credits: {
    titleDe: 'Webdesign & technische Umsetzung',
    titleEn: 'Web design & technical implementation',
    company: 'Software Solution',
    name: 'Ralph-Peter Zillbauer',
    website: 'https://softwaresolution.at',
  },
};
